import { Snackbar, Alert } from "@mui/material"
interface SnackbarAlertProp {
  open: boolean;
  message: string;
  onClose: () => void;
}
export const SnackbarAlert = ({ open, message, onClose }: SnackbarAlertProp) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      autoHideDuration={5000}
      onClose={onClose}>
      <Alert
        onClose={onClose}
        severity="error"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}